import React from 'react';

const About = () => {
  return (
    <div className="about">
      <h2>About ForceSight</h2>
      <p>See your whole org clearly.</p>
    </div>
  );
};

export default About;